import React from 'react';
import { ShowIf } from 'components/utils';

class Text extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      label: this.props.label,
      value: this.props.value,
      red: this.props.red,
      link: this.props.link
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.value != nextProps.value) {
      this.setState({
        value: nextProps.value
      })
    }
  }

  onClick() {
    this.props.onClick()
  }

  render() {
    return (
      <div className={this.props.className}>
        <label className="pt-label">
          <span className="val-title-bold">{this.props.label}</span>
          <ShowIf condition={!this.state.link}>
            <span className={this.state.red ? "val-content-red" : "val-content"}>{String(this.state.value)}</span>
          </ShowIf>
          <ShowIf condition={this.state.link}>
            <span className="val-content txt-blue txt-underline pointer" onClick={this.onClick.bind(this)}>{String(this.state.value)}</span>
          </ShowIf>
        </label>
      </div>
    );
  }
}

Text.defaultProps = {
  className: 'col-input',
  label: '',
  onClick: function() {},
  value: '',
  red: false,
  link: false,
}

export default Text;


// WEBPACK FOOTER //
// ./src/components/tt-forms/common/Text.jsx